module.exports = ".user-active{border-left:3px green solid}.user-inactive{border-left:3px red solid}.user-noaccount{border-left:3px grey solid;opacity:0.7}\n"